<template>
  <div class="message-editor">
    <el-input
      v-model="input"
      type="textarea"
      :placeholder="disabled ? '请稍等...' : '我想问...'"
      resize="none"
      :autosize="{ minRows: 1, maxRows: 3 }"
      :clearable="true"
      :disabled="disabled"
      @keydown.native="inputChange"
      @keyup.native="inputClick"
    >
    </el-input>
    <div class="action-area">
      <el-button type="primary" size="mini" :disabled="isMsgEmpty(input)" @click="onSend"
        >发送</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageEditor',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      input: ''
    }
  },
  methods: {
    onSend() {
      let info = this.input
      this.input = ''
      this.$emit('onSend', info)
    },
    inputChange(event) {
      //获取按下的键的键值
      const keyCode = event.keyCode || event.which
      const altKey = event.altKey
      if (keyCode == 13 && !altKey) {
        event.preventDefault()
      }
    },
    inputClick(event) {
      //获取按下的键的键值
      const keyCode = event.keyCode || event.which
      const altKey = event.altKey
      if (keyCode == 13) {
        if (altKey) {
          this.input += '\n'
        } else if (!this.isMsgEmpty(this.input)) {
          this.onSend()
        }
      }
    },
    isMsgEmpty(msg) {
      if (msg == '') return true
      var reg = '^[ \n]+$'
      var re = new RegExp(reg)
      return re.test(msg)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'message-editor',
  (
    --start-color: #4bc3ff,
    --end-color: #9769ff,
    --disable-start-color: mix(#4bc3ff, #fff, 60%),
    --disable-end-color: mix(#9769ff, #fff, 60%),
    --editor-background-color: #000c13
  ),
  (
    --start-color: #4bc3ff,
    --end-color: #9769ff,
    --disable-start-color: mix(#4bc3ff, #fff, 60%),
    --disable-end-color: mix(#9769ff, #fff, 60%),
    --editor-background-color: rgba(255, 255, 255, 0.19)
  )
);

.message-editor {
  @include adaptation(
    (
      --message-editor-height: 52px,
      --send-btn-height: 44px,
      --common-size-10: 10px
    )
  );
  display: flex;
  padding: var(--base-size-4) var(--base-size-4) var(--base-size-4) var(--base-size-16);
  border-radius: calc(var(--message-editor-height) / 2);
  min-height: var(--message-editor-height);
  border: var(--base-border-width) solid var(--base-color-notice);
  background: var(--editor-background-color);

  .el-textarea {
    /deep/ .el-textarea__inner {
      border-color: transparent;
      color: var(--base-color-white);
      background-color: transparent;
      padding: var(--base-size-8) var(--base-size-16);
      line-height: 2;
    }

    margin-right: var(--base-size-4);
  }

  .action-area {
    display: flex;
    align-items: center;

    .el-button {
      background: linear-gradient(95deg, var(--start-color) 2.68%, var(--end-color) 97.08%);
      color: var(--base-color-white);
      font-size: var(--base-font-size-large);
      height: var(--send-btn-height);
      border-radius: calc(var(--send-btn-height) / 2);
      line-height: var(--base-size-24);
      padding: var(--common-size-10) var(--base-size-32);
      border: none;

      &:hover,
      &:active {
        opacity: 0.8;
      }

      &.is-disabled {
        background: linear-gradient(
          95deg,
          var(--disable-start-color) 2.68%,
          var(--disable-end-color) 97.08%
        );
      }
    }
  }
}
</style>
